import { useExperienceTranslationStore } from "@/features/experience-translation/stores/useExperienceTranslationStore";
import type { ComputedRef } from "vue";

/**
 * Returns a computed boolean indicating whether the current translation is automatic.
 *
 * This is used to suppress modification flow visual indicators (diff highlights,
 * yellow checks) for automatic translations.
 *
 * Currently backed by the translation store; in the future this can be swapped
 * to a dedicated query without changing consumers.
 */
export function useIsCurrentTranslationAutomatic(): ComputedRef<boolean> {
  const translationStore = useExperienceTranslationStore();

  return computed(() => translationStore.translation.translation_type === "AUTOMATIC");
}
